import Vue from 'vue';

export default {
    async setBrightness (data, value) {
        return new Promise((resolve, reject) => {
            var add = value * (255/200);

            for(var i = 0;i<data.length;i+=4){
                data[i+0]+=add;
                data[i+1]+=add;
                data[i+2]+=add;
            }
            resolve(data);
        });
    },
    async setContrast (data, value) {
        return new Promise((resolve, reject) => {
            var contrast = value * (255/200);
            var factor = (259 * (contrast + 255)) / (255 * (259 - contrast))

            for(var i = 0;i<data.length;i+=4){
                data[i+0]=factor*(data[i+0]-128)+128;
                data[i+1]=factor*(data[i+1]-128)+128;
                data[i+2]=factor*(data[i+2]-128)+128;
            }
            resolve(data);
        });
    },
}



// WEBPACK FOOTER //
// ./src/img_manip.js